import React from 'react'
import { BsFillCartFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import './CartWidget.css'

export const CartWidget = () => {
  return (
    <div className='cartWidget'>
        <Link to={'/Cart'}><BsFillCartFill /></Link>
    </div>
  )
}
